window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

require('./web_function')

$(function () {

    let target = $('meta[name="target"]').attr('content')

    if(target){

        switch (target) {
            case 'intellectual-property':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-1", offsetY: 0 } });
                break;

            case 'advanced-technology':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-2", offsetY: 0 } });
                break;

            case 'customization-platform':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-3", offsetY: 0 } });
                break;

            case 'manufacturing-and-commercialization':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-4", offsetY: 0 } });
                break;

            case 'apsd-analytical-services':
                gsap.to(window, { duration: 2, scrollTo: { y: "#rd-section-5", offsetY: 0 } });
                break;
        }
    }

    changeLogoColor()
})

function changeLogoColor() {

    ScrollTrigger.create({
        trigger: "#rd-section-3",
        start: "top top",
        markers:false,
        onEnter: function () {
            switchHeaderBlue(false)
        },
        onEnterBack: function () {
            switchHeaderBlue(false)
        },
        onLeave: function () {
            switchHeaderBlue(true)
        },
        onLeaveBack: function () {
            switchHeaderBlue(true)
        }
    });

    ScrollTrigger.create({
        trigger: "#rd-section-5",
        start: "top top+=1%",
        markers:false,
        onEnter: function () {
            switchHeaderBlue(false)
        },
        onEnterBack: function () {
            switchHeaderBlue(false)
        },
        onLeave: function () {
            switchHeaderBlue(true)
        },
        onLeaveBack: function () {
            switchHeaderBlue(true)
        }
    });

}
